export const usersListingRoutes = [
  {
    path: 'listing',
    name: 'users-listing',
    component: () => import(/* webpackChunkName: "users-listing" */ './UsersListing.vue')
  }
];
